export const theme = {
  primary: {
    THEME: "#146ad3",
    SECONDARY_THEME: "#E8292E",
  },
  danger: {
    DANGER: "#E8292E",
  },
};
